import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconSave';
/** Renders an SVG icon. */
const SvgSave = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M28 6v20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a1 1 0 0 1 .293-.707l5-5A1 1 0 0 1 10 4h16a2 2 0 0 1 2 2m-9 0h-6v2h6zm-8 0v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6h5v20h-4v-8a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8H6V10.414L10.414 6zm1 20h8v-8h-8z"
      />
    </svg>
  );
};
SvgSave.displayName = displayName;
export default SvgSave;
